import ServiceError from "./ServiceError"

import ApiClient from "./ApiClient"

import moment from "moment"

// @todo - put these mappings in an customer specific place

export default class EventService {
  constructor() {
    this.filterableCategories = []

    this.apiClient = new ApiClient(
      "event",
      `${process.env.REMOTE_EVENT_API_ENDPOINT}`
    )
  }

  buildRequestParams(categories, without_category) {
    let params = []

    if (without_category) {
      params.push({ without_category: true })
    }

    if (categories) {
      params.push({ categories: categories })
    } else {
      params.push({ show_filterable_values: true })
    }

    return (
      "?" +
      params
        .map((obj) => {
          return `${Object.keys(obj)[0]}=${obj[Object.keys(obj)[0]]}`
        })
        .join("&")
    )
  }

  apiResultHandler(data) {
    if (!Array.isArray(data.results)) {
      console.error("Unexpected content response", data)
      throw new ServiceError(
        ServiceError.STATUS_INVALID_DATA,
        "Collection service got unexpected data"
      )
    }

    if (data.filterable_values && data.filterable_values.root_categories) {
      this.filterableCategories.unshift(
        ...data.filterable_values?.root_categories
      )
    }

    return {
      root_categories: this.filterableCategories,
      results: data.results,
    }
  }

  async getEvents(categories, without_category) {
    return this.apiResultHandler(
      await this.apiClient.get(
        this.buildRequestParams(categories, without_category)
      )
    )
  }
}
